import React from "react"
import persist from "./persist"
// reducers
import topReducer from "./topReducer"
import mutableReducer from "./mutableReducer"
import { actionObj, stateObj, reducerFunction, initialStateObject} from "../const"


function combineReducers(array: reducerFunction[]) {
    return function(state: stateObj, action: actionObj) {
        console.log(action.type, " >> ", action.payload)
        for (let i = 0; i < array.length; ) {
            const result = array[i](state, action)
            if (Object.is(state, result)) {
                i++
                continue
            } else {
                // saving the new state (result) into the localStorage for persistence purpose
                persist.save(result)
                return result
            }
        }
        persist.save(state)
        return state
    }
}

export const initialState: stateObj = persist.read(initialStateObject)

export default combineReducers([topReducer, mutableReducer])

// toget from browser the state in localStorage:
// JSON.parse(localStorage.getItem("sg_htlclot00hpcht0"))